import React, { ReactNode, useState } from "react";
import { Alert as BootstrapAlert } from "react-bootstrap";
import { Icon } from "..";

export type AlertPurpose = "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark";
export interface AlertProps {
	className?: string;
	purpose: AlertPurpose;
	title?: React.ReactNode | string;
	dismissible?: boolean;
	icon?: string;
	children?: ReactNode;
}

const Alert: React.FC<AlertProps> = ({ className, children, purpose, dismissible = false, title, icon, ...props }) => {
	const [show, setShow] = useState(true);

	const getAlertContent = () => {
		//Create content inside the alert
		return (
			<>
				{title && <BootstrapAlert.Heading>{title}</BootstrapAlert.Heading>}
				{dismissible && (
					<div className="alert-close" onClick={() => setShow(false)}>
						<i className="fal fa-times"></i>
					</div>
				)}

				{children && <div className="alert-body">{children}</div>}
			</>
		);
	};

	return (
		<BootstrapAlert
			className={`alert ${className} ${children ? "has-children" : ""} ${children ? "has-icon" : ""}`}
			variant={purpose}
			show={show}
			onClose={() => setShow(false)}
			{...props}
		>
			{icon ? (
				<>
					<div className="alert-icon">
						<Icon icon={icon} />
					</div>
					<div className="alert-content">{getAlertContent()}</div>
				</>
			) : (
				getAlertContent()
			)}
		</BootstrapAlert>
	);
};

export default Alert;
